module.exports = "/_next/static/images/etc-08f15facb80fa2a51e39b480fcc31007.svg";